var StatusMessageComponentController = (function () {
    function StatusMessageComponentController(statusMessage) {
        this.statusMessage = statusMessage;
    }
    StatusMessageComponentController.prototype.$onInit = function () {
        this.showMessage = this.statusMessage.get() === this.statusCode;
        if (this.showMessage) {
            this.statusMessage.remove();
        }
    };
    StatusMessageComponentController.prototype.hide = function () {
        this.showMessage = false;
    };
    StatusMessageComponentController.$inject = ['statusMessage'];
    return StatusMessageComponentController;
}());
export var StatusMessageComponent = {
    bindings: {
        statusCode: '@',
    },
    controller: StatusMessageComponentController,
    templateUrl: 'compatibilityguide/ng-templates/project/common/statusmessage',
    transclude: {
        body: 'statusMessageBody',
    },
};
